export default __webpack_public_path__ + "scene2_3_icon7b6ea6.png";